import { Link } from 'react-router-dom';

const GOOGLE_CALENDAR_URL = "https://calendar.google.com/calendar/u/0?cid=Y180YzQ3ODY3YTg3ZTczMDNkNDhhZDQ1NjRjODk1MjdiNjA5ZTQ4ODhlMGY3YTcwZDA4N2I3ZTk3OGRiZTA5ZmQxQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20";

const seasonDates = [
    { date: 'Sept 1', event: 'Parent & Student Info Meeting', time: '3:00–5:00 PM (4:30 PM Presentation)', location: 'Esports Lab / Media Center', type: 'meeting' },
    { date: 'Sept 7 – 14', event: 'Signup Window', time: 'Forms Due Sept 14 @ 3:00 PM', location: 'Online Google Form & Main Office', type: 'season' },
    { date: 'Sept 7 – 18', event: 'Pre-Season Practice & Team Formation', time: '3:00 – 5:00 PM', location: 'Esports Lab', type: 'season' },
    { date: 'Sept 21 – Nov 6', event: 'MiHSEF Regular Season Matches', time: 'Mon–Wed 3:00 – 5:00 PM', location: 'Esports Lab / Online', type: 'season' },
    { date: 'Nov 13 – 15', event: 'Grand Rapids Comic Con Trip (Fundraised)', time: 'All Day', location: 'DeVos Place, Grand Rapids', type: 'meeting' },
    { date: 'Nov 16 – 20', event: 'MiHSEF State Playoffs', time: '3:00 – 5:00 PM', location: 'Esports Lab', type: 'playoffs' },
    { date: 'Dec 5', event: 'MiHSEF State Finals', time: 'All Day', location: 'University of Michigan - Flint', type: 'finals' },
];

const weeklySchedule = [
    {
        day: 'Monday',
        focus: 'SSBU Solos & Live Stream',
        coach: 'Coach Anklam',
        activities: [
            { title: 'Super Smash Bros. Solos', division: 'High School & Grade 8 (13+)', platform: 'Nintendo Switch' },
            { title: 'Match Broadcast Crew', division: 'Casters & Stream Techs', platform: 'PC / OBS' },
        ]
    },
    {
        day: 'Tuesday',
        focus: 'SSBU Crews 3v3 & Broadcast',
        coach: 'Coach Anklam',
        activities: [
            { title: 'Super Smash Bros. Crews (3v3)', division: 'Varsity & JV Rosters', platform: 'Nintendo Switch' },
            { title: 'Match Broadcast Crew', division: 'Casters & Stream Techs', platform: 'PC / OBS' },
        ]
    },
    {
        day: 'Wednesday',
        focus: 'Production Focus & Training Day',
        coach: 'Coach Anklam',
        activities: [
            { title: 'Production Studio Workshop', division: 'Graphics, Overlays, Video Editing', platform: 'Adobe / DaVinci' },
            { title: 'Caster Coaching & VOD Review', division: 'Commentary & Scouting', platform: 'Media Lab' },
        ]
    },
];

const dailyOps = [
    { time: '3:00 – 3:45 PM', activity: 'Setup & Warm-Up', note: 'Hardware check, warm-up matches, caster audio test' },
    { time: '3:45 – 4:00 PM', activity: 'Queue & Discord Check-In', note: 'Opponent lobby check-in with MiHSEF league match arbiters' },
    { time: '4:00 – 5:00 PM', activity: 'Official Match Competition & Broadcast', note: 'Varsity/JV match play and live stream recording' },
    { time: '5:00 – 5:15 PM', activity: 'Lab Reset & Dismissal', note: 'Equipment return, log-off, and student pickup' },
];

export default function SchedulePage() {
    const getTypeStyles = (type: string) => {
        switch (type) {
            case 'meeting': return 'bg-yellow-500/20 text-yellow-300 border-yellow-500/40';
            case 'season': return 'bg-green-500/20 text-green-300 border-green-500/40';
            case 'off': return 'bg-secondary-700 text-secondary-300 border-secondary-600';
            case 'playoffs': return 'bg-blue-500/20 text-blue-300 border-blue-500/40';
            case 'finals': return 'bg-primary-500/20 text-primary-300 border-primary-500/40';
            default: return 'bg-secondary-700 text-secondary-300 border-secondary-600';
        }
    };

    return (
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            {/* Header */}
            <div className="text-center mb-8 animate-fade-in">
                <div className="inline-block bg-primary-950 text-primary-300 border border-primary-500/30 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-2">
                    Fall 2026 Season
                </div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-extrabold text-white mb-3">
                    Season <span className="text-primary-500">Schedule</span>
                </h1>
                <p className="text-secondary-200 text-base md:text-lg max-w-2xl mx-auto">
                    Mondays, Tuesdays & Wednesdays • 3:00 – 5:00 PM • High School Esports Lab
                </p>

                {/* Calendar Action Button */}
                <div className="mt-4 flex flex-wrap items-center justify-center gap-3">
                    <a
                        href={GOOGLE_CALENDAR_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Subscribe to Peck Pirates Esports Google Calendar (opens in a new tab)"
                        className="bg-blue-600 hover:bg-blue-500 text-white font-bold text-xs sm:text-sm px-5 py-2.5 rounded-lg transition-colors inline-flex items-center gap-2 shadow-md focus-visible:ring-2 focus-visible:ring-blue-300 focus-visible:outline-none"
                    >
                        <span aria-hidden="true">📅</span>
                        <span>Subscribe / Add to Google Calendar</span>
                        <span aria-hidden="true">↗</span>
                    </a>
                </div>
            </div>

            {/* Season Timeline */}
            <section className="mb-12 animate-slide-up" aria-labelledby="timeline-heading">
                <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
                    <h2 id="timeline-heading" className="text-2xl font-display font-bold text-white flex items-center gap-2">
                        <span aria-hidden="true">📅</span> Key Season Dates
                    </h2>
                    <a
                        href={GOOGLE_CALENDAR_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-xs text-blue-400 hover:text-blue-300 underline font-medium focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:outline-none rounded"
                    >
                        Open Full Google Calendar ↗
                    </a>
                </div>
                <div className="grid gap-3">
                    {seasonDates.map((item, idx) => (
                        <div
                            key={idx}
                            className={`flex flex-wrap md:flex-nowrap items-center justify-between gap-4 p-4 rounded-xl border ${getTypeStyles(item.type)}`}
                        >
                            <div className="w-full md:w-36 font-bold text-white">{item.date}</div>
                            <div className="flex-1 font-medium text-white">{item.event}</div>
                            <div className="text-xs sm:text-sm opacity-90">{item.time}</div>
                            <div className="text-xs sm:text-sm font-semibold opacity-90">{item.location}</div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Weekly Schedule */}
            <section className="mb-12 animate-slide-up" aria-labelledby="weekly-heading">
                <h2 id="weekly-heading" className="text-2xl font-display font-bold text-white mb-4 flex items-center gap-2">
                    <span aria-hidden="true">🎮</span> Weekly Rotation (Mon – Wed, 3–5 PM)
                </h2>
                <div className="grid md:grid-cols-3 gap-6">
                    {weeklySchedule.map((day, idx) => (
                        <div
                            key={idx}
                            className="card border-primary-500/30 bg-secondary-900 p-5 flex flex-col justify-between"
                        >
                            <div>
                                <div className="flex justify-between items-center mb-2">
                                    <h3 className="text-xl font-display font-bold text-white">{day.day}</h3>
                                    <span className="badge-primary text-xs">
                                        {day.coach}
                                    </span>
                                </div>
                                <p className="text-xs font-semibold text-primary-400 mb-4">{day.focus}</p>

                                <div className="space-y-3">
                                    {day.activities.map((act, aIdx) => (
                                        <div key={aIdx} className="py-2 border-b border-secondary-800 last:border-0">
                                            <div className="font-semibold text-white text-sm">{act.title}</div>
                                            <div className="text-xs text-secondary-300 mt-0.5">{act.division}</div>
                                            <span className="inline-block text-[11px] bg-secondary-800 text-secondary-200 px-2 py-0.5 rounded mt-1.5 border border-secondary-700">
                                                {act.platform}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Dual Sport Callout */}
                <div className="mt-6 p-4 bg-yellow-400/10 border border-yellow-400/30 rounded-xl">
                    <p className="text-yellow-300 text-xs sm:text-sm">
                        <strong>🏃 Dual-Sport Friendly:</strong> If you are participating in football, cross country, cheer, or another activity, we coordinate directly with your coach. If you can only attend certain days or matches, that is completely fine!
                    </p>
                </div>
            </section>

            {/* Daily Schedule */}
            <section className="card mb-10 animate-slide-up p-6 bg-secondary-900 border-secondary-700" aria-labelledby="daily-ops-heading">
                <h2 id="daily-ops-heading" className="text-xl font-display font-bold text-white mb-4 flex items-center gap-2">
                    <span aria-hidden="true">⏰</span> Daily Lab Schedule (3:00 – 5:15 PM)
                </h2>
                <div className="space-y-4">
                    {dailyOps.map((op, idx) => (
                        <div key={idx} className="flex flex-col sm:flex-row gap-2 sm:gap-4 items-start pb-3 border-b border-secondary-800 last:border-0">
                            <div className="w-full sm:w-44 font-mono text-primary-400 font-semibold text-sm">{op.time}</div>
                            <div className="flex-1">
                                <div className="font-semibold text-white text-sm">{op.activity}</div>
                                <div className="text-secondary-300 text-xs mt-0.5">{op.note}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Navigation */}
            <div className="flex justify-between items-center pt-4 border-t border-secondary-800">
                <Link to="/games" className="btn-secondary text-sm focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:outline-none">
                    ← Games & Roles
                </Link>
                <Link to="/conduct" className="btn-primary text-sm focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:outline-none">
                    Code of Conduct →
                </Link>
            </div>
        </div>
    );
}


